module.exports = __webpack_public_path__ + "img/home-view-material-portal-logo.de39edb2.png";